import { AppState } from 'src/app/core/core.state'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { OrganizationRequiredSubscriptionService } from './organization-required-subscription.service'
import { concatMap, map, withLatestFrom } from 'rxjs/operators'
import { organizationActions } from './organization.actions'
import { organizationSelectors } from './organization.selectors'

@Injectable()
export class OrganizationRelationEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private organizationRequiredSubscriptionService: OrganizationRequiredSubscriptionService
  ) {}

  createOneRequiredSubscriptionLink = createEffect(() =>
    this.actions$.pipe(
      ofType(organizationActions.createOneRequiredSubscriptionLink),
      concatMap((action) => {
        return this.organizationRequiredSubscriptionService
          .createOne(action.organizationId, action.subscriptionId)
          .pipe(
            withLatestFrom(
              this.store.select(
                organizationSelectors.selectById,
                action.organizationId
              )
            ),
            map(([response, organization]) =>
              organizationActions.upsertOne({
                entity: {
                  ...organization,
                  requiredSubscriptions: [
                    ...(organization?.requiredSubscriptions ?? []),
                    action.subscriptionId
                  ]
                }
              })
            )
          )
      })
    )
  )

  deleteOneRequiredSubscriptionLink = createEffect(() =>
    this.actions$.pipe(
      ofType(organizationActions.deleteOneRequiredSubscriptionLink),
      concatMap((action) =>
        this.organizationRequiredSubscriptionService
          .deleteOne(action.organizationId, action.subscriptionId)
          .pipe(
            withLatestFrom(
              this.store.select(
                organizationSelectors.selectById,
                action.organizationId
              )
            ),
            map(([response, organization]) =>
              organizationActions.upsertOne({
                entity: {
                  ...organization,
                  requiredSubscriptions: [
                    ...organization?.requiredSubscriptions?.filter(
                      (subscriptionId) =>
                        subscriptionId !== action.subscriptionId
                    )
                  ]
                }
              })
            )
          )
      )
    )
  )
}
